module.exports = __webpack_public_path__ + "img/010.cf92f77f.png";